<div *ngIf="currentDocument$ | async as currentDocumentSnapshot" style="margin: 2px;">
  <div *inRole="[roles.EditMetadataFeatureSet]"
    style="display: flex; align-items: center; justify-content: center; padding:6px;">
    <lex-flat-button [label]="editButtonText" [icon]="editIconText" id="edit-metadata-toggle"
      (click)="toggleEdit(!isGlobalEdit)"></lex-flat-button>
  </div>
  <div class="fontify-13px">
    <div class="section-header">
      <span class="area-header">General</span>
    </div>
    <div>
      <div class="grid-list">
        <div class="grid-tile">
          <div class="detail-item">
            <label class="label">Document Id</label>
            <div class="inner-text">{{currentDocumentSnapshot.docId}}</div>
          </div>
        </div>
        <div class="grid-tile">
          <div *ngIf="!isGlobalEdit" style="display: flex;flex-direction: row; align-items: center; width: 100%;">
            <div class="detail-item">
              <label class="label">Bates</label>
              <div class="inner-text">
                {{displayBatesString()}}
              </div>
            </div>
          </div>
          <div *ngIf="isGlobalEdit" style="display: flex; flex-direction: column;">
            <label class="label" style="font-weight: 400;">Bates</label>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 6px;">
              <div class="bates-input-container" [formGroup]="batesFormGroup">
                <input formControlName="batesPrefix" class="bates-prefix" placeholder="Bates Prefix">
                <input formControlName="batesNumberStart" class="bates-number-start" placeholder="Start Number">
                <mat-select formControlName="batesNumberDigits" class="bates-number-digits">
                  <mat-option *ngFor="let digit of batesNumberDigitsOptions" [value]="digit">{{ digit }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div
              *ngIf="batesFormGroup?.errors?.batesNumberStartLength && (batesFormGroup?.dirty || batesFormGroup?.touched)"
              class="error">
              <div>Bates Number Start length must be less than Bates Number Digits.</div>
            </div>
            <div
              *ngIf="batesFormGroup?.get('batesNumberStart').invalid && (batesFormGroup?.get('batesNumberStart').dirty || batesFormGroup?.get('batesNumberStart').touched)"
              class="error">
              <div *ngIf="batesFormGroup?.get('batesNumberStart').errors?.required">Bates Number Start is required.
              </div>
              <div *ngIf="batesFormGroup?.get('batesNumberStart').errors?.pattern">Bates Number Start must be a number.
              </div>
            </div>
            <div
              *ngIf="batesFormGroup?.get('batesPrefix').invalid && (batesFormGroup?.get('batesPrefix').dirty || batesFormGroup?.get('batesPrefix').touched)"
              class="error">
              <div *ngIf="batesFormGroup?.get('batesPrefix').errors?.required">Bates Prefix is required.</div>
            </div>
          </div>
        </div>
        <div *ngIf="currentDocumentSnapshot.common.controlNumber" class="grid-tile">
          <div class="detail-item">
            <label class="label">Control Number</label>
            <div class="inner-text">{{currentDocumentSnapshot.common.controlNumber}}</div>
          </div>
        </div>
        <div class="grid-tile">
          <div class="detail-item">
            <label class="label">Document Source</label>
            <div class="inner-text" style="white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;" [matTooltip]="currentDocumentSnapshot.common.docSource">
              {{currentDocumentSnapshot.common.docSource}}</div>
          </div>
        </div>
        <div *ngIf="custodianName$ | async" class="grid-tile">
          <div class="detail-item">
            <label class="label">Custodian</label>
            <div class="inner-text">{{custodianName$ | async}}</div>
          </div>
        </div>
        <div class="grid-tile">
          <div *ngIf="!isGlobalEdit" style="display: flex;flex-direction: row; align-items: center; width: 100%;">
            <div class="detail-item">
                <label class="label">Source File Path</label>
                <div *ngIf="docViewerStore.documentDataFormGroup.get('sourceFilePath')" class="inner-text" style="white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                width: 100%;" [matTooltip]="docViewerStore.documentDataFormGroup.get('sourceFilePath').value">
                  {{docViewerStore.documentDataFormGroup.get('sourceFilePath').value}}</div>
            </div>
          </div>
          <lex-text-input *ngIf="isGlobalEdit" label="Source File Path"
            [formControl]="docViewerStore.documentDataFormGroup.get('sourceFilePath')"></lex-text-input>
        </div>
        <div *ngIf="currentDocumentSnapshot.native.author" class="grid-tile">
          <div class="detail-item">
            <label class="label">Author</label>
            <div class="inner-text">{{currentDocumentSnapshot.native.author}}</div>
          </div>
        </div>
        <div *ngIf="currentDocumentSnapshot.native.lastModifiedBy" class="grid-tile">
          <div class="detail-item">
            <label class="label">Last Modified by</label>
            <div class="inner-text">{{currentDocumentSnapshot.native.lastModifiedBy}}</div>
          </div>
        </div>
        <div *ngIf="(hasPlaceHolderText$ | async)" class="grid-tile">
          <div class="detail-item">
            <label class="label">Placeholder</label>
            <div class="inner-text">{{(placeHolderText$ | async)}}</div>
          </div>
        </div>
        <div *ngIf="folderName$ | async" class="grid-tile" (click)="folderClick(currentDocumentSnapshot)"
        [ngStyle]="{ 'cursor': isGlobalEdit ? 'pointer' : 'default' }">
          <div class="detail-item">
            <div style="display:flex; flex-direction: row; justify-content: space-between;">
              <label class="label">Folder</label>
              <div *inRole="[roles.EditMetadataFeatureSet]" class="action-item"
              [ngClass]="{'flex': isGlobalEdit, 'none': !isGlobalEdit}">
                <i class="fa-duotone fa-folder-tree action-icon"></i>
              </div>
            </div>
            <div class="inner-text">{{folderName$ | async}}</div>
          </div>
        </div>
        <div class="grid-tile">
          <div *ngIf="!isGlobalEdit" style="display: flex;flex-direction: row; align-items: center; width: 100%;">
            <div class="detail-item">
              <label class="label">Description</label>
              <div *ngIf="this.docViewerStore.documentDataFormGroup.get('description')" class="inner-text">
                {{this.docViewerStore.documentDataFormGroup.get('description').value}}
              </div>
            </div>
          </div>
          <lex-text-input *ngIf="isGlobalEdit" label="Description" [type]="'textarea'"
            [formControl]="docViewerStore.documentDataFormGroup.get('description')"></lex-text-input>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="section-header">
      <div class="area-header" style="font-size: 13px;">Dates</div>
    </div>
    <div>
      <mat-grid-list cols="2" rowHeight="4:1">
        <mat-grid-tile>
          <div class="detail-item">
            <label class="label">Master Date</label>
            <div class="inner-text">{{currentDocumentSnapshot.common.masterDate | date:'M/d/yyyy h:mm:ss a'}}</div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="!isGlobalEdit">
          <div class="detail-item">
            <label class="label">Doc Date</label>
            <div *ngIf="docViewerStore.documentDataFormGroup.get('docDate')" class="inner-text">
              {{docViewerStore.documentDataFormGroup.get('docDate').value | date:'M/d/yyyy h:mm:ss a'}}</div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="isGlobalEdit">
          <div class="detail-item">
            <label class="label" style="font-size: 11px; font-weight: 400;">Doc Date</label>
            <lex-edit-date-input [formControl]="docViewerStore.documentDataFormGroup.get('docDate')"
              style="width:95%"></lex-edit-date-input>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="currentDocumentSnapshot.email.dateSent">
          <div class="detail-item">
            <label class="label">Sent</label>
            <div class="inner-text">{{currentDocumentSnapshot.email.dateSent | date:'M/d/yyyy h:mm:ss a'}}</div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="currentDocumentSnapshot.email.dateReceived">
          <div class="detail-item">
            <label class="label">Received</label>
            <div class="inner-text">{{currentDocumentSnapshot.email.dateReceived | date:'M/d/yyyy h:mm:ss a'}}
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="currentDocumentSnapshot.native.dateCreated">
          <div class="detail-item">
            <label class="label">Create</label>
            <div class="inner-text">{{currentDocumentSnapshot.native.dateCreated | date:'M/d/yyyy h:mm:ss a'}}</div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="currentDocumentSnapshot.native.dateLastModified">
          <div class="detail-item">
            <label class="label">Last Modified</label>
            <div class="inner-text">{{currentDocumentSnapshot.native.dateLastModified | date:'M/d/yyyy h:mm:ss a'}}
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  <div *ngIf="(hasEmailMetadata$ | async) || isGlobalEdit">
    <div class="section-header">
      <div class="area-header" style="font-size: 13px;">Email</div>
    </div>
    <div class="grid-list">
      <div class="grid-tile"
        (click)="openEmailEdit('from', docViewerStore.documentDataFormGroup.get('fromField')?.value)" 
        [ngStyle]="{ 'cursor': isGlobalEdit ? 'pointer' : 'default' }">
        <div style="padding-left: 4px;">
          <div style="display:flex; flex-direction: row; justify-content: space-between;">
            <label class="label">From</label>
            <div *inRole="[roles.EditMetadataFeatureSet]" class="action-item"
              [ngClass]="{'flex': isGlobalEdit, 'none': !isGlobalEdit}">
              <i class="fa-duotone fa-pen-to-square action-icon"></i>
            </div>
          </div>
          <div class="connections-list">
            <div *ngFor="let from of displayConnections('from')" class="connection-item">
              <div class="connection-text" (click)="$event.stopPropagation();">{{from}}</div>
            </div>
            <div *ngIf="showMoreFrom" class="connection-item show-more"
              (click)="showMoreConnections('from');$event.stopPropagation();">See More
            </div>
          </div>
        </div>
      </div>
      <div class="grid-tile" (click)="openEmailEdit('to', docViewerStore.documentDataFormGroup.get('toField')?.value)"
      [ngStyle]="{ 'cursor': isGlobalEdit ? 'pointer' : 'default' }">
        <div style="padding-left: 4px;">
          <div style="display:flex; flex-direction: row; justify-content: space-between;">
            <label class="label">To</label>
            <div *inRole="[roles.EditMetadataFeatureSet]" class="action-item"
              [ngClass]="{'flex': isGlobalEdit, 'none': !isGlobalEdit}">
              <i class="fa-duotone fa-pen-to-square action-icon"></i>
            </div>
          </div>
          <div class="connections-list">
            <div *ngFor="let to of displayConnections('to')" class="connection-item">
              <div class="connection-text" (click)="$event.stopPropagation();">{{to}}</div>
            </div>
            <div *ngIf="showMoreTo" class="connection-item show-more"
              (click)="showMoreConnections('to');$event.stopPropagation();">See More</div>
          </div>
        </div>
      </div>
      <div class="grid-tile" (click)="openEmailEdit('cc', docViewerStore.documentDataFormGroup.get('cc')?.value)"
      [ngStyle]="{ 'cursor': isGlobalEdit ? 'pointer' : 'default' }">
        <div style="padding-left: 4px;">
          <div style="display:flex; flex-direction: row; justify-content: space-between;">
            <label class="label">Cc</label>
            <div *inRole="[roles.EditMetadataFeatureSet]" class="action-item"
              [ngClass]="{'flex': isGlobalEdit, 'none': !isGlobalEdit}">
              <i class="fa-duotone fa-pen-to-square action-icon"></i>
            </div>
          </div>
          <div class="connections-list">
            <div *ngFor="let cc of displayConnections('cc')" class="connection-item">
              <div class="connection-text" (click)="$event.stopPropagation();">{{cc}}</div>
            </div>
            <div *ngIf="showMoreCc" class="connection-item show-more"
              (click)="showMoreConnections('cc');$event.stopPropagation();">See More</div>
          </div>
        </div>
      </div>
      <div class="grid-tile" (click)="openEmailEdit('bcc', docViewerStore.documentDataFormGroup.get('bcc')?.value)"
      [ngStyle]="{ 'cursor': isGlobalEdit ? 'pointer' : 'default' }">
        <div style="padding-left: 4px;">
          <div style="display:flex; flex-direction: row; justify-content: space-between;">
            <label class="label">Bcc</label>
            <div *inRole="[roles.EditMetadataFeatureSet]" class="action-item"
              [ngClass]="{'flex': isGlobalEdit, 'none': !isGlobalEdit}">
              <i class="fa-duotone fa-pen-to-square action-icon"></i>
            </div>
          </div>
          <div class="connections-list">
            <div *ngFor="let bcc of displayConnections('bcc')" class="connection-item">
              <div class="connection-text" (click)="$event.stopPropagation();">{{bcc}}</div>
            </div>
            <div *ngIf="showMoreBcc" class="connection-item show-more"
              (click)="showMoreConnections('bcc');$event.stopPropagation();">See More
            </div>
          </div>
        </div>
      </div>
      <div class="grid-tile">
        <div *ngIf="!isGlobalEdit" style="padding-left: 4px;">
          <label class="label">Subject</label>
          <div *ngIf="docViewerStore.documentDataFormGroup.get('subjectMatter')" class="inner-text" class="detail-item">
            {{docViewerStore.documentDataFormGroup.get('subjectMatter').value}}
          </div>
        </div>
        <lex-text-input *ngIf="isGlobalEdit" label="Subject"
          [formControl]="docViewerStore.documentDataFormGroup.get('subjectMatter')"></lex-text-input>
      </div>
    </div>
  </div>
  <div *inRole="[roles.LimitedFeatureSet]; negative: true" style="padding: 12px; margin-top: 4px;">
    <div>
      <div class="area-header" style="font-size: 13px;">Document History</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center;">
      <ng-container *ngFor="let audit of (audits$ | async | slice:0:2);">
        <mat-card appearance="outlined" class="audit-item" style="width: 320px;">
          <div style="margin-bottom: 4px; font-size: 13px;;">
            <b>{{audit.details}}</b>
          </div>
          <div style="font-size: 11px;">
            {{audit.userName}} at {{audit.auditDate | date:'M/d/yyyy h:mm:ss a'}}
          </div>
        </mat-card>
      </ng-container>
      <ng-container *ngIf="(audits$ | async)?.length > 2">
        <button mat-flat-button class="show-more-audits" (click)="showDocHistoryDialog()"
          style="margin-top: 16px; cursor: pointer; font-size: 13px;">
          <span>View all document history</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>